(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quinni-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('QuinniWelcomePopup');

    if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.designMode === 'true') {
      return;
    }

    const startKey = 'quinniWelcomePopupStartedAt';
    const shownKey = 'quinniWelcomePopupShown';
    const delay = 45000;

    const openDialog = () => {
      if (dialog.open) {
        return;
      }

      try {
        window.sessionStorage.setItem(shownKey, 'true');
      } catch (error) {
      }

      dialog.showModal();
      dialog.querySelector('[data-quinni-popup-close]')?.focus();
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('a[href="#QuinniWelcomePopup"]');

      if (!trigger) {
        return;
      }

      event.preventDefault();
      openDialog();
    });

    let shouldAutoOpen = true;
    let startedAt = Date.now();

    try {
      if (window.sessionStorage.getItem(shownKey) === 'true') {
        shouldAutoOpen = false;
      } else {
        const storedStart = Number(window.sessionStorage.getItem(startKey));

        if (Number.isFinite(storedStart) && storedStart > 0) {
          startedAt = storedStart;
        } else {
          window.sessionStorage.setItem(startKey, String(startedAt));
        }
      }
    } catch (error) {
      startedAt = Date.now();
    }

    if (shouldAutoOpen) {
      const remainingDelay = Math.max(0, delay - (Date.now() - startedAt));
      window.setTimeout(openDialog, remainingDelay);
    }

    dialog.querySelector('[data-quinni-popup-close]')?.addEventListener('click', () => {
      dialog.close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
